module.exports = __webpack_public_path__ + "assets/2485e64018b7e383f6fbf5ee93863143.mp3";